import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * OrphanTracks
 */
export class OrphanTracks {
    /**
     * getList
     */
    static async getList(filter) {
        const result = await NetFetch.postData('/json/orphantracks/list', filter !== null && filter !== void 0 ? filter : {});
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return result;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
    /**
     * match
     */
    static async match(request) {
        const result = await NetFetch.postData('/json/orphantracks/match', request);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return result;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
    /**
     * assign
     */
    static async assign(request) {
        const result = await NetFetch.postData('/json/orphantracks/assign', request);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return result;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
    /**
     * Decoded lat/lon/ts points for one orphan bucket — used by the
     * AssignModal map preview.
     */
    static async getPoints(request) {
        const result = await NetFetch.postData('/json/orphantracks/points', request);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return result;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
    /**
     * Drop the pending-track bucket without promoting it. Echo of the
     * deleted row count comes back on success.
     */
    static async dropBucket(request) {
        const result = await NetFetch.postData('/json/orphantracks/delete', request);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return result;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
}
